/**
 * For GUI elements to render their view. No update of server-state reflecting model allowed.
 *
 * @deprecated Subscribe to the Cadenza store instead.
 */
export const COMMAND_UPDATE = 'command:update';
